// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonWrapper } from "@eisinc/MobiusOverrides/Button";
import { actionsStyles } from "@eisinc/Overrides/Widgets/ProductList/ProductListActions";
import { css } from "styled-components";

actionsStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        gap: 8px;
    `,
};

actionsStyles.productActions = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            gap: 8px;
            > div:last-child {
                flex: 1;
            }
        `,
    },
    productAddToCartButtonStyles: {
        css: css`
            padding: 0;
            width: 100%;
        `,
    },
    uomSelect: {
        cssOverrides: {
            inputSelect: css`
                width: 91px;
            `,
        },
    },
};

actionsStyles.addToListWrapper = {
    css: css`
        display: flex;
        justify-content: space-between;
        margin-top: auto;
    `,
};

actionsStyles.addToListLink = {
    wrapper: {
        css: css`
            display: flex;
        `,
    },
};

actionsStyles.compareCheckbox = {
    css: css`
        margin-left: auto;
    `,
};
